// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"25ccc201","915":"25ccc201"}[chunkId] + ".chunk.css";
};